<template>
    <!--todo 可使用的優惠-->
    <div class="ticket_list" v-if="useType">
        <div v-for="(item,index) in list"
             :key="index"
             class="list_content">
            <el-image class="img" :src="item.titleImage" fit="cover" @click.native="toCouponDetail(item,true,disable[index], index)">>
                <div slot="error" class="image-slot"/>
            </el-image>
            <div class="info" @click="toCouponDetail(item,true,disable[index], index)">
                <div class="title">
                    <span class="text">{{item.name}}</span>
                    <span class="num">{{item.count}}</span>
                </div>
                <div class="red">
                    <!--todo 使用期限和即將失效-->
                    {{item.convertLimitType === 2 ? item.startTime+"~無限制" : (Date.parse(item.endTime+'T24:00:00+08:00')-new Date().getTime())/(1000*60*60)>24?item.startTime+'~'+item.endTime:'剩餘'+Math.round((Date.parse(item.endTime+'T24:00:00+08:00')-new Date().getTime())/(1000*60*60))+'小時'}}
                </div>
            </div>

            <number-controller :params="{index: index, default: amount[index], min: 0, max:Number(item.count)}" @triggerEvent="numberControllerEvent" :size="'mini'"/>

        </div>
    </div>
    <!--todo 不可使用的優惠-->
    <div class="ticket_list" v-else>
        <div class="list_content" v-for="(item,index) in list" :key="index"
             @click="toCouponDetail(item,false)">
            <el-image class="img" :src="item.titleImage" fit="cover">
                <div slot="error" class="image-slot"/>
            </el-image>
            <div class="info">
                <div class="title"><span class="text">{{item.name}}</span></div>
                <div class="red">
                    <!--todo 使用期限和即將失效-->
                    {{item.convertLimitType === 2 ? item.startTime+"~無限制" : (Date.parse(item.endTime+'T24:00:00+08:00')-new Date().getTime())/(1000*60*60)>24?item.startTime+'~'+item.endTime:'剩餘'+Math.round((Date.parse(item.endTime+'T24:00:00+08:00')-new Date().getTime())/(1000*60*60))+'小時'}}
                </div>
                {{notAbleUseContent(item)}}
            </div>
        </div>
    </div>
</template>

<script>

    import NumberController from "@/components/NumberController";

    export default {
        name: "PickCouponCover",
        components: {
          NumberController
        },
        props: {
            list:{},
            amount:{},//優惠券數量
            disable:{},//被disable的couponChoiceList
            couponChoice:{},//優惠券詳細
            useType:{default: true},//區別可否使用優惠券
        },
        watch: {

        },
        data() {
            return {

            }
        },
        mounted() {

        },
        methods: {
            toCouponDetail(item, ableUse, disAbled, index){
                disAbled = disAbled !== undefined ? disAbled : false;
                let isUsed = this.couponChoice.indexOf(item.code) >= 0 || item.choiceAmount > 0;
                //等0.2秒才跳頁，怕有原生鍵盤還未收回就跳頁會跑版
                setTimeout(() => {
                    this.$router.push({name: 'OrderCouponDetail',query:{couponId:item.couponListId, ableUse: ableUse, isUsed: isUsed, disAbled: disAbled, choiceCode: item.code}});
                }, 200);
            },
            numberControllerEvent(obj) {
              let self = this;
              let event = obj.event;

              if (event === "returnNumber") {
                let couponChoiceListInputArr = JSON.parse(JSON.stringify(self.amount))
                couponChoiceListInputArr[obj.index] = obj.number
                this.$emit('triggerEvent', {
                  event: "UpdateCouponChoiceListInputArr",
                  couponChoiceListInputArr: couponChoiceListInputArr,
                })
              }
            },
            notAbleUseContent(item) {
                let content = ''
                switch (item.notAbleUseType) {
                    case 1:
                        content = '未滿足可使用額度'
                        break;
                    case 2:
                        content = '尚未生效'
                        break
                    case 3:
                        content = '既有優惠不可與其優惠共用'
                        break;
                    case 4:
                        content = `需有「${item.posFoodName}」才可使用`
                        break;
                }

                return content
            }
        }
    }
</script>

<style lang="less" scoped>
    .ticket_list{
        width: 100%;
        padding: 0 15px 15px 15px;
        .list_content {
            width: 100%;
            padding:10px 0;
            border-bottom: 1px solid var(--color-gray);
            position: relative;
            overflow: hidden;
            display: flex;
            align-items: center;
        }
        .img {
            width: 50px;
            height: 50px;
            overflow: hidden;
            border-radius: 10px;
        }
        .info {
            flex: 1;
            padding-left: 10px;
            line-height: 1.5;
            overflow: hidden;
            .title {
                font-size: 17px;
                line-height: 1;
                color: #302D2C;
                margin: 3px 0 5px;
                text-align: left;
                display: flex;
                align-items: center;
                .text{
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                .num{
                    flex: 0 0 20px;
                    height: 18px;
                    line-height: 18px;
                    background: var(--color-yellow4);
                    color: #fff;
                    text-align: center;
                    display: inline-block;
                    border-radius: 16px;
                    font-size: 12px;
                    margin-left: 5px;
                }
            }
        }
        .red {
            font-size: 12px;
        }
    }
</style>
